export default {
  created() {
    this.fetchAutoSuggest();
  },
  methods: {
    fetchAutoSuggest() {
      const autosuggestDataKey = `autosuggestData:${this.$root.config.cacheVersion}`;
      if (this.$root.config.autosuggestLinksURL) {
        if (!sessionStorage.getItem(autosuggestDataKey)) {
          fetch(this.$root.config.autosuggestLinksURL)
            .then(response => response.json())
            .then(data => {
              this.$root.autosuggestData = data;
              sessionStorage.setItem(autosuggestDataKey, JSON.stringify(data));
            })
            .catch(() => {
              // console.log(err);
            });
        } else {
          this.$root.autosuggestData = JSON.parse(sessionStorage.getItem(autosuggestDataKey));
        }
      }
    },
  },
};
